// extracted by mini-css-extract-plugin
export default {"section-gallery":"homePageBanners_section-gallery__XouX1","performance-divider":"homePageBanners_performance-divider__hKmoo"};